import { BoomGateIcon } from './BoomGateIcon';

/**
 * author: Michael Richins
 * id D24517D5-27A6-4BE4-B9C8-C575A1431310
 * name boom-gate
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boom-gate.svg
 * tags
 * - Transportation + Road 
 * - Home Automation 
 */
export const AutomaticGateIcon = BoomGateIcon;
export default AutomaticGateIcon